import React from "react";
import { handleDefaultProfile } from "../utils/helperFunctions";
import useZustandStore from "../zustandStore/useZustandStore";

/** Profile API returns `roles` as string[]; join for display when multiple. */
const formatRoles = (roles) => {
  if (Array.isArray(roles)) return roles.filter(Boolean).join(", ");
  if (roles == null || roles === "") return "";
  return String(roles);
};

const Profile = () => {
  const { setOpenLogoutConf } = useZustandStore();
  const currentUser = useZustandStore((state) => state?.currentUser);
  const { name, email, roles, created_on, signedup_on, avatar } = currentUser || {};
  const joinedOn = created_on || signedup_on;
  const rolesText = formatRoles(roles);

  return (
    <div className="min-h-[calc(100vh-30px)] bg-gray-50 flex flex-col items-center">
      {/* Profile Hero */}
      <div className="mt-12 w-full max-w-4xl flex flex-col items-center">
        <div className="relative">
          {avatar ? (
            <img
              src={
                handleDefaultProfile({ userName: name, avatar: currentUser?.avatar })
              }
              alt={currentUser?.name}
              className="w-36 h-36 rounded-full bg-gradient-to-tr from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center text-white text-5xl font-bold shadow-xl"
            />
          ) : (
            <div className="w-36 h-36 rounded-full bg-gradient-to-tr from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center text-white text-5xl font-bold shadow-xl">
              {name ? name[0].toUpperCase() : "U"}
            </div>
          )}
          <span className="absolute bottom-0 right-0 bg-white text-gray-900 text-xs font-semibold px-3 py-1 rounded-full shadow-md border max-w-[min(280px,85vw)] truncate text-left" title={rolesText || "User"}>
            {rolesText || "User"}
          </span>
        </div>

        {/* User Info */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-full max-w-5xl">
          <div className="text-center">
            <p className="text-gray-400 text-sm tracking-wider">FULL NAME</p>
            <p className="text-lg font-medium text-gray-900">{name || "—"}</p>
          </div>
          <div className="text-center">
            <p className="text-gray-400 text-sm tracking-wider">EMAIL</p>
            <p className="text-lg font-medium text-gray-900 break-all">{email || "—"}</p>
          </div>
          <div className="text-center">
            <p className="text-gray-400 text-sm tracking-wider">ROLE</p>
            <p className="text-lg font-medium text-gray-900">{rolesText || "—"}</p>
          </div>
          <div className="text-center">
            <p className="text-gray-400 text-sm tracking-wider">JOINED ON</p>
            <p className="text-lg font-medium text-gray-900">
              {joinedOn
                ? new Date(joinedOn).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                : "—"}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <button
            onClick={() => setOpenLogoutConf(true)}
            className="px-6 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition-all"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
